<template>
  <section
    class="mobile_add_new_head bg--blue tx--bege center flex flex--content--center relative no-print"
  >
    <a class="m_bt_head" @click.prevent="$emit('approveGoBack')">
      חזרה
    </a>
    <div class="title">
      סיכום פרטי ניתוח
    </div>
    <a
      class="m_bt_head head_go_back flex m-flex--center link_goback"
      @click.prevent="$emit('approveGoBack')"
    >
      <ArrowBackSvg />
    </a>
    <a
      v-if="isInfo && surgeryType != 'ivf' && surgBeforeToday"
      class="m_bt_head head_save"
      @click.prevent="$emit('onEdit')"
    >
      עריכה
    </a>
    <a
      v-if="!isInfo"
      class="m_bt_head head_save"
      @click.prevent="$emit('approve')"
    >
      אישור
    </a>
  </section>
</template>

<script>
import ArrowBackSvg from "@/assets/img/svg/arrow_r.svg";

export default {
  name: "ApproveMobileHeader",
  props: ["surgeryType", "isInfo", "surgBeforeToday"],
  components: {
    ArrowBackSvg
  }
};
</script>
